import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { downloadResidentialProfilePdf, downloadResidentialProfilePdfPoi, resetResidentialProfile } from "../../../redux/actions/documents/resendentialProfile";
import { ResidentialProfileState } from "../../../redux/reducers/getDocumentReducer/residentialProfile";
import { RootState } from "../../../redux/reducers/root";
import AmpInlineLoadingSpinner from "../../common/AmpInlineLoadingSpinner/AmpInlineLoadingSpinner";
import "./DownloadPoiProfile.css";

export interface DownloadPoiProfileProps {
    poiRoll?: string;
    isParent?: boolean;
}

export default function DownloadPoiProfile(props: DownloadPoiProfileProps) {

    const { t } = useTranslation(["nbhd"]);

    const docState = useSelector((state: RootState) => state.docReducer.downloadPdf as ResidentialProfileState);
    const manageUserInfoState: Record<string, unknown> = useSelector((state: RootState) => state.authReducer.getUser);

    const [loading, setLoading] = useState(false);

    const dispatch = useDispatch();

    const poiRoll = props.poiRoll ? props.poiRoll.replace(/ /g, '') : false;

    const handleClick = () => {
        dispatch(resetResidentialProfile())
        let userLanguage = window.localStorage.getItem("prefLang");
        if (!userLanguage) {
            if (manageUserInfoState.pref_lang) {
                userLanguage = manageUserInfoState.pref_lang as string;
            } else {
                userLanguage = "en_EN";
            }
        }
        const parentRoll = localStorage.getItem("currentProperty") as string;
        const oType = localStorage.getItem("o_type") as string;
        const profileId = localStorage.getItem("userProfileId") as string;

        if (props.isParent) {
            dispatch(downloadResidentialProfilePdf(profileId, parentRoll, userLanguage, "N"))
        } else {
            dispatch(downloadResidentialProfilePdfPoi(
                profileId, parentRoll, userLanguage, oType, poiRoll as string, "N"
            ));
        }


        setLoading(true)
    }


    useEffect(() => {

        const save = (pdf: string, roll: string, isLink: boolean) => {
            setLoading(false);
            let linkSource: string;
            if (isLink){
                linkSource = pdf
            } else {
                linkSource = `data:application/pdf;base64,${pdf}`;
            }
            const downloadLink = document.createElement("a");
            const fileName = `Property_Profile_${roll}.pdf`;
            downloadLink.href = linkSource;
            downloadLink.download = fileName;
            downloadLink.click();
            downloadLink.remove();
            dispatch(resetResidentialProfile());
        }

        if (docState["data"] && !docState["loading"]) {
            if ((docState["data"] as Record<string, unknown>)["poi_roll"] === poiRoll && docState["found"] && poiRoll) {
                save(docState["pdf"] as string, poiRoll, docState["is_link"] as boolean);
            }
        } else if (docState["roll"] && !docState["loading"] && props.isParent) {
            if (docState["roll"] === localStorage.getItem("currentProperty") && docState["found"]) {
                save(docState["pdf"] as string, docState["roll"], docState["is_link"] as boolean);
            }
        }
    }, [docState, poiRoll, props.isParent, dispatch])

    return (
        <div className="download-link" onClick={(e) => { handleClick(); }}>
            <span>{t("nbhd.POI.download-pdf")}</span>
            <span>{loading && <AmpInlineLoadingSpinner />}</span>
        </div>

    )
}